import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke321aRequest, Sgke321aResponse, Sgke321aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke321aService {

  /**
   * コンストラクタ
   * @param {Sgke321aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke321aService
   */
  constructor(
    private service: Sgke321aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * SGKE321A_供給停止作業割当初期表示API呼び出し
   * @param {Sgke321aRequest} request
   * @return {*}  {Observable<Sgke321aResponse>}
   * @memberof UsedSgke321aService
   */
  public doSgke321a(request: Sgke321aRequest): Observable<Sgke321aResponse> {
    return this.service.sgke321aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE321A');
          return throwError(err.message);
        })
      );
  }
}
